// 히트펌프 통합 관제 - 기기/필터/탭 상수
// TODO: 실제 API 연동 전까지 시연용 샘플 데이터 사용

export const DASHBOARD_TAB = {
  OVERVIEW: 'overview',
  DEVICES: 'devices',
  FORECAST: 'forecast',
};

// hidden: true 인 탭은 상단 탭 버튼을 숨김 (화면/코드는 유지)
export const DASHBOARD_TAB_LIST = [
  { key: DASHBOARD_TAB.OVERVIEW, label: '대시보드', title: '히트펌프 통합 관제' },
  { key: DASHBOARD_TAB.DEVICES, label: '운전현황', title: '기기별 운전현황', hidden: true },
  { key: DASHBOARD_TAB.FORECAST, label: 'HEATCAST 예측', title: 'HEATCAST 수요예측', hidden: true },
];

export const PERIOD_TYPE = {
  HOUR: 'hour',
  DAY: 'day',
  MONTH: 'month',
};

export const PERIOD_LIST = [
  { key: PERIOD_TYPE.HOUR, label: '시간별' },
  { key: PERIOD_TYPE.DAY, label: '일자별' },
  { key: PERIOD_TYPE.MONTH, label: '월별' },
];

export const DEVICE_STATUS = {
  RUN: '운전',
  IDLE: '대기',
  CHECK: '점검',
};

export const FILTER_ALL = 'all';

export const HP_DEVICES = [
  { id: 'HP-SEO-001', maker: 'LG', region: '서울', mode: '난방', kw: 4.8, today: 45.2, cop: 3.8, status: DEVICE_STATUS.RUN },
  { id: 'HP-SEO-002', maker: 'Samsung', region: '서울', mode: '난방', kw: 3.2, today: 32.8, cop: 3.5, status: DEVICE_STATUS.RUN },
  { id: 'HP-GGI-003', maker: 'Daikin', region: '경기', mode: '온수', kw: 5.4, today: 51.4, cop: 3.9, status: DEVICE_STATUS.RUN },
  { id: 'HP-GGI-004', maker: 'LG', region: '경기', mode: '대기', kw: 0, today: 18.5, cop: null, status: DEVICE_STATUS.IDLE },
  { id: 'HP-JJU-005', maker: 'Samsung', region: '제주', mode: '난방', kw: 2.9, today: 28.1, cop: 3.6, status: DEVICE_STATUS.RUN },
  { id: 'HP-JJU-006', maker: 'Daikin', region: '제주', mode: '대기', kw: 0, today: 16.3, cop: null, status: DEVICE_STATUS.IDLE },
  { id: 'HP-GGI-007', maker: 'Samsung', region: '경기', mode: '난방', kw: 4.1, today: 39.7, cop: 3.7, status: DEVICE_STATUS.RUN },
  { id: 'HP-SEO-008', maker: 'LG', region: '서울', mode: '점검', kw: 0, today: 7.6, cop: null, status: DEVICE_STATUS.CHECK },
];
